import { CartActions } from '../actions';

export const initialState: any | null = null;

export function voucherErrorReducer(state = initialState, action: CartActions.CartVoucherAction): any | null {
  switch (action.type) {
    case CartActions.CART_ADD_VOUCHER_FAIL:
      return action.payload.error;

    case CartActions.CART_ADD_VOUCHER:
      return null;

    default:
      return state;
  }
}
